import { cva, type VariantProps } from 'class-variance-authority'

export { default as Button } from './Button.vue'

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-md font-medium ring-offset-slate-950 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-300 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-75 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'bg-transparent text-white hover:text-brand-primary',
        destructive: 'dark:bg-red-900 dark:text-white dark:hover:bg-red-900/90',
        outline: 'dark:border-slate-800 bg-transparent text-white hover:text-brand-primary',
        secondary: 'bg-transparent text-white hover:text-brand-primary',
        ghost: 'bg-transparent text-white hover:text-brand-primary',
        link: 'bg-transparent text-white underline-offset-4 hover:text-brand-primary',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export type ButtonVariants = VariantProps<typeof buttonVariants>